module.exports = __webpack_public_path__ + "4b98330abecd561d74fc602ba34a6999.png";